import { render, staticRenderFns } from "./table.vue?vue&type=template&id=3ed4a078&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style1 from "./table.vue?vue&type=style&index=1&id=3ed4a078&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4a078",
  null
  
)

export default component.exports